export default __webpack_public_path__ + "images/admin-transaction-type-card-locked.svg";